// components/SloganCard/SloganCard.jsx
import React from "react";
import "./SloganCard.css";

const SloganCard = () => {
  return (
    <div className="slogan-card">
      <i className="fas fa-brain slogan-icon"></i>
      <h3 className="slogan-title">لغات رو قورت بده!</h3>
      <p className="slogan-description">
        ذخیره لغات و اصطلاحات، مرور با لایتنر حرفه‌ای
      </p>
    </div>
  );
};

export default SloganCard;
